// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetArticlesListRequestModel from '../../model/get-articles-list-request-model';
import GetArticlesListRequestDTO from '../dto/get-articles-list-request-dto';
import dtoSchema from '../schemas/get-articles-list-request-schema';

export default abstract class GetArticlesListRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetArticlesListRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.language = data.language;
      this.categoryId = data.categoryId;
      this.searchTerm = data.searchTerm;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  */
  language?: string;
  /**
  */
  categoryId?: string;
  /**
  */
  searchTerm?: string;

  static toModel(dto: DeepPartial<GetArticlesListRequestDTO>): GetArticlesListRequestModel;
  static toModel(dto: DeepPartial<GetArticlesListRequestDTO> | undefined | null): GetArticlesListRequestModel | undefined;
  static toModel(dto: DeepPartial<GetArticlesListRequestDTO> | undefined | null): GetArticlesListRequestModel | undefined {
    return dto ? new GetArticlesListRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetArticlesListRequestModel> | GetArticlesListRequestModel): GetArticlesListRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      language: unwrapped.language,
      categoryId: unwrapped.categoryId,
      searchTerm: unwrapped.searchTerm,
    } as GetArticlesListRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetArticlesListRequestModel, can not map to GetArticlesListRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
